// extracted by mini-css-extract-plugin
export default {"instructions":"EstimatedDateParcelInstructions_instructions__tQbng"};